
import React, { useState } from 'react';
import FormAutocomplete from 'components/FormFields/FormAutocomplete';
import { countries } from 'utils/countries';

const CountryWidget = ({
  value,
  onChange,
  ...restProps
}) => {
  const [options, setOptions] = useState(countries);

  const handleInputChange = (e) => {
    const q = e.target.value;
    if (q === '') {
      setOptions(countries);
      return;
    }

    const newOptions = countries.filter(({ label }) => {
      if (label && label.toLowerCase().includes(q.toLowerCase())) return true;
      return false;
    });
    setOptions(newOptions);
  };

  const handleOptionSelect = (_value) => {
    const found = countries.find((item) => item.value === _value);
    if (found) onChange(found);
  };

  const renderOption = (props, i) => {
    const { label, value: _value } = props;
    return (
      <button
        key={`autocomplete-option-button-${i}`}
        className="button--unstyled autocomplete__option"
        onClick={() => handleOptionSelect(_value)}
        onMouseDown={(e) => e.preventDefault()}
      >
        {label}
      </button>
    );
  };

  const handleValueSubmit = (_value) => {
    const found = countries.find((item) => item.label === _value);
    if (found) onChange(found);
    else onChange({ value: _value, label: _value });
  };

  return (
    <FormAutocomplete
      {...restProps}
      options={options}
      value={value.label}
      onSubmit={handleValueSubmit}
      onInputChange={handleInputChange}
      renderOption={renderOption}
      submitOnBlur
    />
  );
};

export default CountryWidget;
